const FRAME_INITIALIZE_REQUESTED = 'FRAME_INITIALIZE_REQUESTED'

export default {
  FRAME_INITIALIZE_REQUESTED,
}
